export default "__VITE_ASSET__2fe41f46__"